import React from 'react';
import { Globe } from 'lucide-react';
import AdminLayout from '../../components/layout/AdminLayout';
import WebsiteVisionPanel from '../../components/WebsiteVisionPanel';

export default function WebsiteVisionBuilder() {
  return (
    <AdminLayout title="Website Vision Builder">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6" data-testid="website-vision-page">
        <div className="flex items-center gap-3 mb-5">
          <span className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#1D4ED8] to-[#F97316] flex items-center justify-center text-white"><Globe size={20} /></span>
          <div>
            <h1 className="text-2xl font-black text-[#0A0F1C] tracking-tight">Website Vision Builder</h1>
            <p className="text-sm text-[#64748B]">Capture or design their site vision, then get an AI Build Brief and a full paste-ready Emergent build prompt.</p>
          </div>
        </div>
        <WebsiteVisionPanel base="/api/admin/website-vision" q="?person=all" library />
      </div>
    </AdminLayout>
  );
}
